module.exports = __webpack_public_path__ + "img/Fault-Separator.26ba54a5.svg";